import script from "./ShiftChangeHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShiftChangeHistory.vue?vue&type=script&setup=true&lang=ts"

import "./ShiftChangeHistory.vue?vue&type=style&index=0&id=667c3f91&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-667c3f91"]])

export default __exports__